'use client';
import { jsx } from 'react/jsx-runtime';
import { useComboBox } from '@react-aria/combobox';
import { useFilter } from '@react-aria/i18n';
import { useComboBoxState } from '@react-stately/combobox';
import { createContext, useCallback, useRef, useMemo } from 'react';
import { useListboxList, SwanListboxListContext } from '../listbox/listbox-list.context.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { SwanPopoverContextProvider } from '../popover/popover.context.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const SwanComboboxContext = createContext(void 0);
function SwanComboboxContextProvider(l) {
    let { children: p, onSelectionChange: x, selectedKey: d, disableAutoFilter: f = false, 'aria-label': v, 'aria-labelledby': C, inputValue: h, defaultInputValue: S, onInputChange: y, menuTrigger: w = 'input', allowsCustomValue: g, allowEmptyCollection: P = false, maxHeight: j } = l, { childItems: k, items: I, disabledKeys: V } = useCollectionContext(), E = useCallback((o)=>{
        var t;
        let e = 'number' == typeof o ? o : null !== (t = null == o ? void 0 : o.toString()) && void 0 !== t ? t : '';
        null == x || x(null != e ? e : '');
    }, [
        x
    ]), { contains: F } = useFilter({
        sensitivity: 'base'
    }), O = useComboBoxState({
        children: k,
        items: I,
        defaultFilter: f ? void 0 : F,
        onSelectionChange: E,
        selectedKey: d,
        inputValue: h,
        defaultInputValue: S,
        onInputChange: y,
        allowsCustomValue: g,
        allowsEmptyCollection: P,
        menuTrigger: w
    }), R = useRef(null), W = useRef(null), q = useRef(null), z = useRef(null), A = useRef(null), { buttonProps: B, inputProps: D, listBoxProps: G, labelProps: H } = useComboBox({
        'aria-label': v,
        'aria-labelledby': C,
        menuTrigger: w,
        inputRef: W,
        buttonRef: R,
        listBoxRef: z,
        popoverRef: A,
        disabledKeys: V
    }, O), J = useModeExtractor(W, O.isOpen), K = useMemo(()=>({
            popoverRef: A,
            triggerRef: (null == q ? void 0 : q.current) ? q : W,
            overlayState: O,
            fullWidth: true,
            modes: J,
            maxHeight: j
        }), [
        W,
        A,
        q,
        O,
        J,
        j
    ]), L = useMemo(()=>({
            buttonProps: B,
            inputProps: D,
            labelProps: H,
            buttonRef: R,
            inputRef: W,
            triggerRef: q,
            setInputValue: O.setInputValue,
            menuTrigger: w
        }), [
        B,
        D,
        H,
        O,
        w
    ]), M = useListboxList(G, z, O);
    return jsx(SwanPopoverContextProvider, {
        value: K,
        children: jsx(SwanComboboxContext.Provider, {
            value: L,
            children: jsx(SwanListboxListContext.Provider, {
                value: M,
                children: p
            })
        })
    });
}
function useSwanComboboxContext() {
    return useNonNullishContext(SwanComboboxContext);
}

export { SwanComboboxContext, SwanComboboxContextProvider, useSwanComboboxContext };
